import { render, staticRenderFns } from "./forex-ebc-ea-turbo.vue?vue&type=template&id=0b63c5ea&scoped=true"
import script from "./forex-ebc-ea-turbo.vue?vue&type=script&lang=js"
export * from "./forex-ebc-ea-turbo.vue?vue&type=script&lang=js"
import style0 from "./forex-ebc-ea-turbo.vue?vue&type=style&index=0&id=0b63c5ea&prod&lang=css"
import style1 from "./forex-ebc-ea-turbo.vue?vue&type=style&index=1&id=0b63c5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b63c5ea",
  null
  
)

export default component.exports